<template>
  <div/>
</template>
<script>
import { Toast } from 'vant'
export default {
  methods: {
    openViewer(params = {}) {
      if (params && params.value) {
        var segs = params.value.split(',', 4)
        if (segs.length === 4) {
          params = Object.assign({}, {
            latitude: (segs[0] && parseFloat(segs[0])) || 0,
            longitude: (segs[1] && parseFloat(segs[1])) || 0,
            name: segs[2],
            address: segs[3],
          }, params)
        }
      }
      
      this.openMapViewer(params).then(() => {
        this.close(true)
      }).catch(err => {
        Toast.fail({
          message: err.message,
          icon: 'none',
          duration: 3000
        })
        this.close(false)
      })
    },


    close(e) {
      this.$emit("close", e);
    },

    // 初始化地图并且调用
    openMapViewer({latitude, longitude, name, address, scale}) {
      const f = (resolve, reject) => {
        if (!window.wx) {
          return reject({
            message: '暂时不支持'
          });
        }
        window.wx.openLocation({
          latitude: (latitude && Number(latitude)) || 0,
          longitude: (longitude && Number(longitude)) || 0,
          name: name || '',
          address: address || '',
          scale: scale || 18,
          success: (res) => {
            console.log("Success openLocation: ", {latitude, longitude, name, address, scale}, res)
            resolve(res)
          },
          fail: (err) => {
            console.log("Fail openLocation: ", {latitude, longitude, name, address, scale}, err)
            reject(err)
          },
          complete: () => {
            console.log("Complete openLocation")
          }
        });
      } 
      if (!latitude || !longitude) {
        return new Promise((resolve, reject) => {
          window.wx.getLocation({
            type: 'gcj02',
            success: (res) => {
              latitude = res.latitude
              longitude = res.longitude
              f(resolve, reject)
            } 
          })
        })
      }
      return new Promise(f)
    },

  },
};
</script>
<style lang="scss" scoped>
</style>